<template>
  <video :src="video" controls ref="video" muted="muted"></video>
</template>

<script>
export default {
  name: 'VideoPage',
  data() {
    return {
      video: ''
    }
  },
  mounted() {
    this.getVideo()
  },
  methods: {
    getVideo() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_element/get_video_chunk`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          video_data: JSON.parse(this.$route.query.video_data)
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.video = data
          this.$nextTick(() => this.$refs[`video`].play())
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    }
  }
}
</script>

<style scoped lang="scss">
video {
  width: 100vw;
  height: 100vh;
}
</style>
